import React, { Component } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';

import './ProcessSettings.css';
import EpsgSelect, { isCatalogEpsg, sourceOptions, destinationOptions, ahdDestinationCount } from './EpsgSelect';
import { isEpsgTransform, readEpsgSettings, writeEpsgSettings, validateEpsgSettings, epsgNotice } from './epsgSettings';

class ProcessSettings extends Component {

    constructor(props) {
        super(props);

        this.state = {
            errMsg: ''
        };
    }

    onLoad = () => {
        this.setState({ errMsg: '' });
    }

    updateEpsg = (key, value) => {
        const values = readEpsgSettings(this.props.process.HiddenParam);
        values[key] = value;
        this.setState({ errMsg: '' });
        this.props.handleUpdateHiddenParam({ target: { value: writeEpsgSettings(values) } });
    }

    save = () => {
        let errMsg = isEpsgTransform(this.props.process) ? validateEpsgSettings(this.props.process.HiddenParam) : '';
        if (!errMsg && isEpsgTransform(this.props.process)) {
            const values = readEpsgSettings(this.props.process.HiddenParam);
            if (!isCatalogEpsg(values.sourceEpsg, true)) errMsg = 'Select a source UTM coordinate system from the list.';
            else if (!isCatalogEpsg(values.targetEpsg)) errMsg = 'Select a destination coordinate system from the list.';
        }
        this.setState({ errMsg });
        if (!errMsg) this.props.handleSaveProcessSettings();
    }

    render() {
        const epsg = readEpsgSettings(this.props.process.HiddenParam);
        return (

            <Modal
              show={this.props.showProcessSettings}
              onHide={this.props.hideProcessSettings}
              onEntered={this.onLoad}
              backdrop="static"
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 className="pageTitle">Process Settings</h1></center></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                <Form className="ProcessSettingsForm">
                    <Form.Row>
                        <Form.Group as={Col} controlId="frmProcessName">
                            <Form.Label className="ProcessLabel">Process</Form.Label>
                            <Form.Control className="ProcessSettingsName" type="text" value={this.props.process.Name} readOnly plaintext/>
                        </Form.Group>
                    </Form.Row>

                    {isEpsgTransform(this.props.process) ? <>
                        <Form.Row>
                            <Form.Group as={Col} controlId="frmSourceEpsg">
                                <Form.Label>From EPSG (UTM)</Form.Label>
                                <EpsgSelect inputId="frmSourceEpsg" value={epsg.sourceEpsg} source
                                    onChange={value => this.updateEpsg('sourceEpsg', value)} />
                                <Form.Text className="text-muted">Choose the raw map’s datum, zone and hemisphere from {sourceOptions.length.toLocaleString()} UTM coordinate systems.</Form.Text>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="frmTargetEpsg">
                                <Form.Label>To EPSG (destination)</Form.Label>
                                <EpsgSelect inputId="frmTargetEpsg" value={epsg.targetEpsg} ahd={epsg.targetHeight === 'ahd'}
                                    onChange={value => this.updateEpsg('targetEpsg', value)} />
                                <Form.Text className="text-muted">Search all {destinationOptions.length.toLocaleString()} destination coordinate systems by EPSG code or name.</Form.Text>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="frmTargetHeight">
                                <Form.Label>Output heights</Form.Label>
                                <Form.Control as="select" style={{ color: '#000', backgroundColor: '#fff' }} value={epsg.targetHeight}
                                    onChange={event => this.updateEpsg('targetHeight', event.target.value)}>
                                    <option value="preserve">Keep source heights (horizontal transform only)</option>
                                    <option value="ahd">AHD — convert ellipsoidal heights using AUSGeoid2020</option>
                                </Form.Control>
                                <Form.Text className="text-muted">AHD is available with {ahdDestinationCount.toLocaleString()} destination horizontal coordinate systems, within AUSGeoid2020 coverage. Exports use an _ahd.las filename and include horizontal and vertical CRS metadata.</Form.Text>
                            </Form.Group>
                        </Form.Row>
                        <p style={{ color: '#000' }}>Use the datum of the GPS correction service or base station. UTM zone 56 south with GDA2020 corrections is EPSG:7856.</p>
                        {epsgNotice(epsg) && <div role="status" className="alert alert-info" style={{ color: '#000' }}>{epsgNotice(epsg)}</div>}
                        <p className="text-muted">Converts gps-global.las when available (otherwise global_georeferenced_wildcat.las) and saves a new LAS map in the recording’s output folder. The original map is kept. Open the new EPSG-suffixed LAS to view it; a JSON report beside it records the source, destination and sampled coordinate changes.</p>
                    </> : <>
                    <Form.Row>
                        <Form.Group as={Col} controlId="frmHiddenParam">
                            <Form.Label className="ProcessLabel">Default Parameters</Form.Label>
                            <Form.Control as="textarea" rows={4} className="ProcessSettingsParam" placeholder="param1;param2;param3" value={this.props.process.HiddenParam || ''} onChange={this.props.handleUpdateHiddenParam}/>
                            <Form.Text className="text-muted">
                                Semicolon-separated parameters passed to this process when it runs over a recording.
                            </Form.Text>
                        </Form.Group>
                    </Form.Row>
                    </>}

                </Form>
            </div>
            </Modal.Body>

            <Modal.Footer>
                <span className="ProcessSettingsErr">{this.state.errMsg || this.props.error}</span>
                <Button onClick={this.save}>Save</Button>
                <Button onClick={this.props.hideProcessSettings}>Close</Button>
            </Modal.Footer>
            </Modal>
        )
    }
}

export default ProcessSettings;
